module.exports = __webpack_public_path__ + "img/示例图_5-2.e2bb5386.png";